import React, { useEffect, useState } from 'react';
import '../css/App.css';
import API_BASE from './apiBase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faClipboardList, faCookieBite, faHeadset, faListCheck, faEnvelope, faCreditCard, faCloud, faGlobe } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import UserManagementPage from './UserManagementPage';
import ConsentPage from './ConsentPage';
import SubCategoryConsents from './SubCategoryConsents';
import MultilingualConsentPage from './MultilingualConsentPage';
import SubMultilingualConsentPage from './SubMultilingualConsentPage';
import NotificationPanel from './notification';
import ManagerDetailsForm from './Data_Type';
import DPSForm from './dps';
import ManagerHelpManagement from './ManagerHelpManagement';
import ManagerFAQManagement from './ManagerFAQManagement';
import Department from './Department';
import WebConsentPage from './WebConsentPage';
import SubscriptionModal from './SubscriptionModal'; // ← NEW
import { DRIVE_OPTIONS, buildDriveRequestPayload, getDriveOption } from './driveDataUtils';

function ManagerPanel({ token, user, onLogout, page, setPage }) {
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [subcategoryTarget, setSubcategoryTarget] = useState('');
  const [multilingualConsentTarget, setMultilingualConsentTarget] = useState(null);
  const [subMultilingualConsentTarget, setSubMultilingualConsentTarget] = useState(null);

  // Step-1 mini modal (plan selector)
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState(1);
  const [selectedUsers, setSelectedUsers] = useState(1);

  // Step-2 full SubscriptionModal (Create Subscription form)
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const [driveModalOpen, setDriveModalOpen] = useState(false);
  const [selectedDrive, setSelectedDrive] = useState(() => {
    try {
      return window && window.localStorage ? (window.localStorage.getItem('consent_selected_drive') || 'google-drive') : 'google-drive';
    } catch (e) {
      return 'google-drive';
    }
  });
  const [driveLoading, setDriveLoading] = useState(false);
  const [driveResult, setDriveResult] = useState(null);
  const [driveError, setDriveError] = useState('');
  const [driveAccessKey, setDriveAccessKey] = useState(() => {
    try {
      return window && window.localStorage ? (window.localStorage.getItem('drive_access_key') || '') : '';
    } catch (e) {
      return '';
    }
  });
  const [driveAccessToken, setDriveAccessToken] = useState(() => {
    try {
      return window && window.localStorage ? (window.localStorage.getItem('drive_access_token') || '') : '';
    } catch (e) {
      return '';
    }
  });
  // ── OAuth sign-in state (Google Drive / One Drive) ──
  const [googleSignedIn, setGoogleSignedIn] = useState(false);
  const [oneDriveSignedIn, setOneDriveSignedIn] = useState(false);
  const [googleAccountEmail, setGoogleAccountEmail] = useState('');
  const [oneDriveAccountEmail, setOneDriveAccountEmail] = useState('');
  const [oauthConnecting, setOauthConnecting] = useState(false);
  const [gsiReady, setGsiReady] = useState(false);
  const [googleClientOverride, setGoogleClientOverride] = useState(() => {
    try {
      return window && window.localStorage ? (window.localStorage.getItem('google_client_override') || '') : '';
    } catch (e) {
      return '';
    }
  });
  const [msClientOverride, setMsClientOverride] = useState(() => {
    try {
      return window && window.localStorage ? (window.localStorage.getItem('ms_client_override') || '') : '';
    } catch (e) {
      return '';
    }
  });
  const [driveClientSecret, setDriveClientSecret] = useState(() => {
    try {
      return window && window.localStorage ? (window.localStorage.getItem('drive_client_secret') || '') : '';
    } catch (e) {
      return '';
    }
  });
  const [isDriveConnected, setIsDriveConnected] = useState(() => {
    try {
      return window && window.localStorage ? (window.localStorage.getItem('drive_is_connected') === 'true') : false;
    } catch (e) {
      return false;
    }
  });
  // Drive Test-Connection state (manual — user clicks Test Drive first, then Connect Drive)
  const [driveTesting, setDriveTesting] = useState(false);
  const [driveTestPassed, setDriveTestPassed] = useState(false);
  const [driveTestMsg, setDriveTestMsg] = useState({ type: '', text: '' });

  const resetDriveTestState = () => {
    setDriveTestPassed(false);
    setDriveTestMsg({ type: '', text: '' });
  };

  const handleDisconnectDrive = () => {
    setIsDriveConnected(false);
    setDriveTestPassed(false);
    setDriveTestMsg({ type: '', text: '' });
    setDriveResult(null);
    setGoogleSignedIn(false);
    setOneDriveSignedIn(false);
    setGoogleAccountEmail('');
    setOneDriveAccountEmail('');
    setDriveAccessKey('');
    setDriveAccessToken('');
    setDriveClientSecret('');
    setGoogleClientOverride('');
    setMsClientOverride('');
    try {
      if (window && window.localStorage) {
        window.localStorage.removeItem('drive_is_connected');
        window.localStorage.removeItem('google_client_override');
        window.localStorage.removeItem('ms_client_override');
        window.localStorage.removeItem('drive_client_secret');
        window.localStorage.removeItem('drive_access_key');
        window.localStorage.removeItem('drive_access_token');
      }
    } catch (e) {}
  };
  const [smtpModalOpen, setSmtpModalOpen] = useState(false);
  const initialSmtpForm = () => ({
    host: '',
    port: '587',
    username: '',
    password: '',
    from_address: '',
    use_tls: true,
    test_email: '',
  });
  const [smtpForm, setSmtpForm] = useState(initialSmtpForm());
  const [smtpSaving, setSmtpSaving] = useState(false);
  const [smtpMessage, setSmtpMessage] = useState('');
  const [smtpLoadedOnce, setSmtpLoadedOnce] = useState(false);
  // SMTP Test-Connection state (manual — user clicks Test first, then Save)
  const [smtpTesting, setSmtpTesting] = useState(false);
  const [smtpTestPassed, setSmtpTestPassed] = useState(false);  // true only after a successful test
  const [smtpTestMsg, setSmtpTestMsg] = useState({ type: '', text: '' }); // {type:'ok'|'err', text}

  const tier1Rate = parseInt(process.env.REACT_APP_TIER1_RATE || '299', 10);
  const tier2Rate = parseInt(process.env.REACT_APP_TIER2_RATE || '249', 10);
  const tier3Rate = parseInt(process.env.REACT_APP_TIER3_RATE || '225', 10);

  function rateForUsers(count) {
    if (count <= 5) return tier1Rate;
    if (count <= 15) return tier2Rate;
    return tier3Rate;
  }
  function calculateTotalINR() {
    return rateForUsers(selectedUsers) * selectedUsers * selectedMonths;
  }
  function formatINR(n) {
    return Number(n || 0).toFixed(2);
  }

  // ── Load Google Identity Services script once (for real Google sign-in) ──
  useEffect(() => {
    if (window.google && window.google.accounts && window.google.accounts.oauth2) {
      setGsiReady(true);
      return;
    }
    const existing = document.getElementById('gsi-client-script');
    if (existing) {
      existing.addEventListener('load', () => setGsiReady(true));
      return;
    }
    const script = document.createElement('script');
    script.id = 'gsi-client-script';
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => setGsiReady(true);
    script.onerror = () => setGsiReady(false);
    document.body.appendChild(script);
  }, []);

  // ── Real Google sign-in (OAuth token popup) for Google Drive ──
  const handleGoogleSignIn = () => {
    setDriveError('');
    if (!gsiReady || !window.google || !window.google.accounts || !window.google.accounts.oauth2) {
      setDriveError('Google sign-in is still loading, please try again in a moment.');
      return;
    }
    const clientId = (googleClientOverride && googleClientOverride.trim()) || org?.google_client_id || process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!clientId) {
      setDriveError('Google sign-in is not configured for this tenant or globally. Please ask your administrator to add a tenant-specific Google OAuth client ID, or paste a client ID into the "Google Client ID (override)" box below to test.');
      return;
    }
    try {
      setOauthConnecting(true);
      const tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: 'https://www.googleapis.com/auth/drive.file',
        callback: (tokenResponse) => {
          setOauthConnecting(false);
          if (tokenResponse && tokenResponse.access_token) {
            setDriveAccessToken(tokenResponse.access_token);
            setDriveAccessKey(clientId);
            setGoogleSignedIn(true);
            setDriveError('');
            fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
              headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
            })
              .then((r) => (r.ok ? r.json() : null))
              .then((info) => {
                if (info && info.email) {
                  const signedEmail = (info.email || '').toLowerCase();
                  const tenantEmail = (org?.manager_email || '').toLowerCase();
                  if (tenantEmail && signedEmail !== tenantEmail) {
                    setDriveError(`Signed Google account (${info.email}) does not match tenant manager email (${org?.manager_email}). Please sign in with the tenant manager account.`);
                    setGoogleSignedIn(false);
                    setDriveAccessToken('');
                    setDriveAccessKey('');
                    setGoogleAccountEmail('');
                  } else {
                    setGoogleAccountEmail(info.email);
                  }
                }
              })
              .catch(() => { });
          } else {
            setDriveError('Google sign-in failed. Please try again.');
          }
        },
        error_callback: (err) => {
          setOauthConnecting(false);
          console.warn('Google OAuth error', err);
          setDriveError(
            'Google Sign-In Error (401: invalid_client / no registered origin). Please ensure your Client ID is correct and "http://localhost:3000" (or your current web domain) is added under "Authorized JavaScript origins" in Google Cloud Console Credentials.'
          );
        },
      });
      // tokenclient.requestAccessToken();
      // Re-consent is required after changing from the old read-only scope.
      tokenClient.requestAccessToken({ prompt: 'consent' });
    } catch (e) {
      setOauthConnecting(false);
      setDriveError('Unable to start Google sign-in.');
    }
  };

  // ── Real Microsoft sign-in (OAuth token popup) for One Drive ──
  const handleOneDriveSignIn = () => {
    setDriveError('');
    const clientId = (msClientOverride && msClientOverride.trim()) || org?.ms_client_id || process.env.REACT_APP_MS_CLIENT_ID;
    if (!clientId) {
      setDriveError('One Drive sign-in is not configured for this tenant or globally. Please ask your administrator to add a tenant-specific Microsoft OAuth client ID, or paste a Microsoft OAuth client ID into the override box below to test.');
      return;
    }
    if (clientId.includes('@')) {
      setDriveError('The Microsoft Client ID must be a client ID string, not an email address. Please paste the Azure app client ID here.');
      return;
    }
    const redirectUri = `${window.location.origin}/oauth-callback.html`;
    const scope = encodeURIComponent('Files.Read.All offline_access openid profile');
    const authUrl =
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize` +
      `?client_id=${encodeURIComponent(clientId)}` +
      `&response_type=token` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&scope=${scope}` +
      `&response_mode=fragment`;

    setOauthConnecting(true);
    const popup = window.open(authUrl, 'onedrive-login', 'width=500,height=650');
    if (!popup) {
      setOauthConnecting(false);
      setDriveError('Popup blocked. Please allow popups and try again.');
      return;
    }

    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (!event.data || event.data.type !== 'onedrive-token') return;
      window.removeEventListener('message', handleMessage);
      setOauthConnecting(false);
      try { popup.close(); } catch (e) { }
      const hash = event.data.hash || '';
      const params = new URLSearchParams(hash.replace(/^#/, ''));
      const accessToken = params.get('access_token');
      if (accessToken) {
        setDriveAccessToken(accessToken);
        setDriveAccessKey(clientId);
        setOneDriveSignedIn(true);
        setDriveError('');
        fetch('https://graph.microsoft.com/v1.0/me', {
          headers: { Authorization: `Bearer ${accessToken}` },
        })
          .then((r) => (r.ok ? r.json() : null))
          .then((info) => {
            const email = info && (info.mail || info.userPrincipalName);
            if (email) {
              const signedEmail = (email || '').toLowerCase();
              const tenantEmail = (org?.manager_email || '').toLowerCase();
              if (tenantEmail && signedEmail !== tenantEmail) {
                setDriveError(`Signed Microsoft account (${email}) does not match tenant manager email (${org?.manager_email}). Please sign in with the tenant manager account.`);
                setOneDriveSignedIn(false);
                setDriveAccessToken('');
                setDriveAccessKey('');
                setOneDriveAccountEmail('');
              } else {
                setOneDriveAccountEmail(email);
              }
            }
          })
          .catch(() => { });
      } else {
        setDriveError('Microsoft sign-in failed. Please try again.');
      }
    };
    window.addEventListener('message', handleMessage);

    const popupCheck = setInterval(() => {
      if (popup.closed) {
        clearInterval(popupCheck);
        window.removeEventListener('message', handleMessage);
        setOauthConnecting(false);
      }
    }, 700);
  };

  const handleTestDrive = async () => {
    if (!org?.id) {
      setDriveError('No tenant selected');
      setDriveTestPassed(false);
      setDriveTestMsg({ type: 'err', text: 'No tenant selected' });
      return;
    }

    try {
      setDriveTesting(true);
      setDriveError('');
      setDriveResult(null);
      setDriveTestPassed(false);
      setDriveTestMsg({ type: '', text: '' });

      const activeClientId = selectedDrive === 'google-drive'
        ? (googleClientOverride || org?.google_client_id || driveAccessKey)
        : selectedDrive === 'one-drive'
        ? (msClientOverride || org?.ms_client_id || driveAccessKey)
        : driveAccessKey;

      const payload = buildDriveRequestPayload(org.id, selectedDrive, {
        clientId: activeClientId,
        clientSecret: driveClientSecret,
        accessKey: driveAccessKey,
        accessToken: driveAccessToken,
      });

      const res = await axios.post(`${API_BASE}/manager/drive-data`, payload, {
        headers: { Authorization: `Bearer ${token}`, 'X-Drive-Type': selectedDrive, 'X-Google-Drive-Token': driveAccessToken },
      });

      const data = res.data || { success: true, drive_type: selectedDrive };
      setDriveResult(data);
      setDriveTestPassed(true);
      const fileMsg = typeof data.file_count === 'number' ? ` (${data.file_count} files found)` : '';
      setDriveTestMsg({
        type: 'ok',
        text: `Drive Connection Test Successful! Connected to ${data.drive_label || getDriveOption(selectedDrive).label}${fileMsg}. You can now click "Connect Drive".`,
      });
    } catch (err) {
      setDriveTestPassed(false);
      const errMsg = err?.response?.data?.detail || err?.message || 'Drive connection test failed.';
      setDriveError(errMsg);
      setDriveTestMsg({ type: 'err', text: errMsg });
    } finally {
      setDriveTesting(false);
    }
  };

  const handleConnectDrive = async () => {
    if (!org?.id) {
      setDriveError('No tenant selected');
      return;
    }

    if (!driveTestPassed) {
      await Swal.fire({
        title: 'Test Drive First',
        text: 'Please click "Test Drive" and verify the connection is successful before connecting.',
        icon: 'info',
        customClass: { popup: 'swal-popup-custom' },
      });
      return;
    }

    try {
      setDriveLoading(true);
      const activeClientId = selectedDrive === 'google-drive'
        ? (googleClientOverride || org?.google_client_id || driveAccessKey)
        : selectedDrive === 'one-drive'
        ? (msClientOverride || org?.ms_client_id || driveAccessKey)
        : driveAccessKey;

      setIsDriveConnected(true);
      if (window && window.localStorage) {
        window.localStorage.setItem('drive_is_connected', 'true');
        window.localStorage.setItem('consent_selected_drive', selectedDrive);
        window.localStorage.setItem('drive_client_id', activeClientId || '');
        window.localStorage.setItem('drive_client_secret', driveClientSecret || '');
        if (driveAccessKey.trim()) window.localStorage.setItem('drive_access_key', driveAccessKey.trim());
        if (driveAccessToken.trim()) window.localStorage.setItem('drive_access_token', driveAccessToken.trim());
      }

      await Swal.fire({
        title: 'Drive Connected!',
        text: `${getDriveOption(selectedDrive).label} has been connected for ${org.name || 'your organization'}. All attachment files will be stored in this drive.`,
        icon: 'success',
        timer: 2500,
        showConfirmButton: false,
        customClass: { popup: 'swal-popup-custom' },
      });

      setDriveModalOpen(false);
    } catch (e) {
      setDriveError('Failed to connect drive.');
    } finally {
      setDriveLoading(false);
    }
  };

  const loadSmtpConfig = async () => {
    if (!org?.id || smtpLoadedOnce) {
      return;
    }
    try {
      const res = await axios.get(`${API_BASE}/manager/smtp-config?tenant_id=${org.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res?.data?.success && res.data.config) {
        setSmtpForm({
          host: res.data.config.host || '',
          port: res.data.config.port ? String(res.data.config.port) : '587',
          username: res.data.config.username || '',
          password: '',
          from_address: res.data.config.from_address || '',
          use_tls: res.data.config.use_tls !== false,
          test_email: res.data.config.test_email || '',
        });
      }
      setSmtpLoadedOnce(true);
    } catch (err) {
      console.warn('Unable to load SMTP config', err);
    }
  };

  const getFileUrl = (url) => {
    if (!url) return url;
    if (url.startsWith('/uploads')) {
      return `${API_BASE}${url}`;
    }
    return url;
  };

  const getFileDownloadUrl = (url) => {
    if (!url) return url;
    if (url.startsWith('/uploads')) {
      return `${API_BASE}/manager/download-drive-file?path=${encodeURIComponent(url)}`;
    }
    return url;
  };

  // ── SMTP: manual Test Connection (no DB write) ─────────────────────
  const handleSmtpTest = async () => {
    setSmtpTesting(true);
    setSmtpTestPassed(false);
    setSmtpTestMsg({ type: '', text: '' });
    setSmtpMessage('');
    try {
      if (!smtpForm.host.trim() || !smtpForm.username.trim() || !smtpForm.from_address.trim()) {
        throw new Error('SMTP Host, Username and From Address are required.');
      }
      if (!smtpForm.test_email.trim()) {
        throw new Error('Please enter a Test Email address so we can verify the connection.');
      }
      const res = await axios.post(`${API_BASE}/manager/smtp-test`, {
        host: smtpForm.host,
        port: parseInt(smtpForm.port || '587', 10),
        username: smtpForm.username,
        password: smtpForm.password || undefined,
        from_address: smtpForm.from_address,
        use_tls: smtpForm.use_tls,
        test_email: smtpForm.test_email,
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (res?.data?.connected && res?.data?.test_sent) {
        setSmtpTestPassed(true);
        setSmtpTestMsg({ type: 'ok', text: `Connection successful! Test email delivered to ${smtpForm.test_email}. You can now save.` });
      } else {
        setSmtpTestPassed(false);
        setSmtpTestMsg({ type: 'err', text: res?.data?.test_error || 'Connection failed. Check your SMTP credentials.' });
      }
    } catch (err) {
      setSmtpTestPassed(false);
      setSmtpTestMsg({ type: 'err', text: err?.response?.data?.detail || err?.message || 'SMTP test failed.' });
    } finally {
      setSmtpTesting(false);
    }
  };

  // ── SMTP: save to smtp_consent table — only after test passes ──────
  const handleSmtpSave = async () => {
    if (!org?.id) {
      setSmtpMessage('No tenant selected');
      await Swal.fire({ title: 'Missing tenant', text: 'No tenant selected.', icon: 'warning' });
      return;
    }
    if (!smtpTestPassed) {
      await Swal.fire({
        title: 'Test First',
        text: 'Please click "Test Connection" and confirm the connection is successful before saving.',
        icon: 'info',
      });
      return;
    }
    try {
      setSmtpSaving(true);
      setSmtpMessage('');
      if (!smtpForm.host.trim() || !smtpForm.username.trim() || !smtpForm.from_address.trim()) {
        throw new Error('SMTP host, username, and from address are required.');
      }
      const payload = {
        tenant_id: org.id,
        host: smtpForm.host,
        port: parseInt(smtpForm.port || '587', 10),
        username: smtpForm.username,
        password: smtpForm.password || undefined,
        from_address: smtpForm.from_address,
        use_tls: smtpForm.use_tls,
        test_email: smtpForm.test_email,
      };
      const res = await axios.post(`${API_BASE}/manager/smtp-config`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res?.data?.success) {
        setSmtpLoadedOnce(false);
        await Swal.fire({ title: 'Saved!', text: 'SMTP settings saved successfully.', icon: 'success', timer: 2000, showConfirmButton: false });
        setSmtpModalOpen(false);
        setSmtpForm(prev => ({ ...prev, password: '' }));
        setSmtpTestPassed(false);
        setSmtpTestMsg({ type: '', text: '' });
      } else {
        throw new Error(res?.data?.detail || 'Failed to save SMTP settings.');
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.detail || err?.message || 'Failed to save SMTP settings';
      setSmtpMessage(errorMessage);
      await Swal.fire({ title: 'Save failed', text: errorMessage, icon: 'error' });
    } finally {
      setSmtpSaving(false);
    }
  };

  useEffect(() => {
    const fetchOrg = async () => {
      setLoading(true);
      setError('');
      try {
        const tenantRes = await axios.get(`${API_BASE}/admin/tenants`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const tenant = tenantRes.data.find(t => {
          const matchesEmail = (t.manager_email || '').toLowerCase() === (user.email || '').toLowerCase();
          const matchesTenantId = user && (user.tenant_id || user.tenantId || user.tenant)
            ? String(t.id) === String(user.tenant_id || user.tenantId || user.tenant)
            : false;
          return matchesEmail || matchesTenantId;
        });
        let plan = '';
        if (tenant) {
          const subRes = await axios.get(`${API_BASE}/admin/subscriptions?tenant_id=${tenant.id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          plan = subRes.data && subRes.data.length > 0 ? subRes.data[0].plan : '';
        }
        setOrg({
          id: tenant ? tenant.id : '',
          name: tenant ? tenant.name : '',
          plan,
          manager_email: user.email,
          address: tenant?.address || '',
          gst_number: tenant?.gst_number || '',
          pan_number: tenant?.pan_number || '',
          google_client_id: tenant?.google_client_id || '',
          ms_client_id: tenant?.ms_client_id || '',
        });
      } catch (err) {
        setError('Failed to load organization info');
      } finally {
        setLoading(false);
      }
    };
    fetchOrg();
    // eslint-disable-next-line
  }, []);

  // SSE notifications
  useEffect(() => {
    if (!org || !org.id) return;
    const url = `${API_BASE}/manager/notifications/stream?tenant_id=${org.id}`;
    let es;
    try { es = new EventSource(url); } catch (e) { console.warn('EventSource not available', e); return; }
    es.onmessage = (e) => {
      try {
        const payload = JSON.parse(e.data);
        if (payload) {
          if (payload.type === 'cookie_consent') {
            alert(`Cookie consent ${payload.consent_status.toUpperCase()}\nTenant: ${payload.tenant_id}\nSession: ${payload.session_id || 'N/A'}`);
          } else if (payload.type === 'consent_response') {
            alert(`Consent ${(payload.consent_status || '').toLowerCase()}\nTenant: ${payload.tenant_id}\nConsent ID: ${payload.consent_id}`);
            try { document.dispatchEvent(new CustomEvent('consentResponse', { detail: payload })); } catch (e) { }
          }
        }
      } catch (err) { console.error('Invalid SSE payload', err); }
    };
    es.onerror = (err) => console.warn('SSE error', err);
    return () => { try { if (es) es.close(); } catch (e) { } };
  }, [org]);

  if (loading) return <div className="manager-panel-beautiful">Loading...</div>;
  if (error) return <div className="manager-panel-beautiful error-message">{error}</div>;
  if (!org) return <div className="manager-panel-beautiful">No organization found for this manager.</div>;

  // ── Page routing ──────────────────────────────────────────────────
  if (page === 'users')
    return <UserManagementPage token={token} tenantId={org.id} onBack={() => setPage('dashboard')} />;

  if (page === 'consent')
    return (
      <ConsentPage
        tenantId={org.id} token={token}
        onBack={() => setPage('dashboard')}
        onOpenSubcategories={(cat) => { setSubcategoryTarget(cat); setPage('subcategories'); }}
        onOpenMultilingualConsent={(consent) => { setMultilingualConsentTarget(consent); setPage('multilingual-consent'); }}
        onSubmit={async data => {
          try {
            await axios.post(
              `${API_BASE}/manager/create-consent`,
              { tenant_id: org.id, consent_type: data.consent_type, consent_message: data.consent_message },
              { headers: { Authorization: `Bearer ${token}` } }
            );
            setPage('dashboard');
          } catch (err) {
            alert('Failed to create consent: ' + (err?.response?.data?.detail || err.message));
          }
        }}
      />
    );

  if (page === 'subcategories')
    return <SubCategoryConsents category={subcategoryTarget?.key || subcategoryTarget} parentConsentId={subcategoryTarget?.id || null} parentConsentLabel={subcategoryTarget?.label || ''} tenantId={org.id} token={token} onBack={() => setPage('consent')} onOpenSubMultilingual={(consent) => { setSubMultilingualConsentTarget(consent); setPage('sub-multilingual-consent'); }} />;

  if (page === 'multilingual-consent')
    return <MultilingualConsentPage parentConsent={multilingualConsentTarget} tenantId={org.id} token={token} onBack={() => setPage('consent')} />;

  if (page === 'sub-multilingual-consent')
    return <SubMultilingualConsentPage parentConsent={subMultilingualConsentTarget} tenantId={org.id} token={token} onBack={() => setPage('subcategories')} />;

  if (page === 'notification')
    return <NotificationPanel tenantId={org.id} token={token} onBack={() => setPage('dashboard')} />;

  if (page === 'DPS' || page === 'DSAR')
    return <DPSForm />;

  if (page === 'Data_Types')
    return <ManagerDetailsForm tenantId={org.id} token={token} onBack={() => setPage('dashboard')} />;

  if (page === 'Department')
    return <Department tenantId={org.id} token={token} onBack={() => setPage('dashboard')} />;

  if (page === 'help-management')
    return <ManagerHelpManagement tenantId={org.id} token={token} onBack={() => setPage('dashboard')} />;

  if (page === 'faq-management')
    return <ManagerFAQManagement tenantId={org.id} token={token} onBack={() => setPage('dashboard')} />;

  if (page === 'webapp-consent')
    return <WebConsentPage onBack={() => setPage('dashboard')} />;

  // ── Dashboard ─────────────────────────────────────────────────────
  return (
    <div className="manager-panel-beautiful">
      <div
        className="manager-header-beautiful"
        onClick={() => setPage('managerDetailsForm')}
        style={{ cursor: 'pointer' }}
        title="Open Manager Details Form"
      >
        <div>
          <div className="org-title">Organization</div>
          <div className="org-name">{org.name}</div>
        </div>
        <div className="manager-info">
          <div className="info-row"><span className="info-label">Manager Email:</span> <span className="info-value">{org.manager_email}</span></div>
          <div className="info-row"><span className="info-label">Plan:</span> <span className="info-value">{org.plan || 'Free'}</span></div>
        </div>
      </div>

      <div className="manager-cards-row">
        <div
          className="manager-card subscription-card"
          onClick={() => { setSelectedMonths(1); setSelectedUsers(1); setSubscriptionOpen(true); }}
        >
          <FontAwesomeIcon icon={faCreditCard} className="manager-card-icon subscription" />
          <div className="manager-card-title">Subscription</div>
          <div className="manager-card-desc">Current plan: <strong>{org.plan || 'Free'}</strong></div>
          <button
            className="manager-card-btn"
            onClick={e => { e.stopPropagation(); setSelectedMonths(1); setSelectedUsers(1); setSubscriptionOpen(true); }}
          >
            Manage Subscription
          </button>
        </div>

        <div className="manager-card user-card" onClick={() => setPage('users')}>
          <FontAwesomeIcon icon={faUsers} className="manager-card-icon user" />
          <div className="manager-card-title">User Management</div>
          <div className="manager-card-desc">Add and edit users for your organization.</div>
          <button className="manager-card-btn">Manage Users</button>
        </div>

        <div className="manager-card consent-card" onClick={() => setConsentModalOpen(true)}>
          <FontAwesomeIcon icon={faClipboardList} className="manager-card-icon consent" />
          <div className="manager-card-title">Consent Creation</div>
          <div className="manager-card-desc">Create and manage consent templates and records.</div>
          <button className="manager-card-btn" onClick={e => { e.stopPropagation(); setConsentModalOpen(true); }}>Create Consent</button>
        </div>

        <div className="manager-card cookie-card" onClick={() => setPage('cookie-consent-template')}>
          <FontAwesomeIcon icon={faCookieBite} className="manager-card-icon cookie" />
          <div className="manager-card-title">Cookie Banner Creation</div>
          <div className="manager-card-desc">Design and deploy cookie banners for compliance.</div>
          <button className="manager-card-btn">Create Banner</button>
        </div>

        <div className="manager-card help-card" onClick={() => setPage('help-management')}>
          <FontAwesomeIcon icon={faHeadset} className="manager-card-icon help" />
          <div className="manager-card-title">Help</div>
          <div className="manager-card-desc"> DPO contact information</div>
          <button className="manager-card-btn">Open</button>
        </div>

        <div className="manager-card faq-card" onClick={() => setPage('faq-management')}>
          <FontAwesomeIcon icon={faListCheck} className="manager-card-icon faq" />
          <div className="manager-card-title">FAQs</div>
          <div className="manager-card-desc">Create and manage frequently asked questions</div>
          <button className="manager-card-btn">Manage FAQs</button>
        </div>

        <div className="manager-card webconsent-card" onClick={() => setPage('webapp-consent')}>
          <FontAwesomeIcon icon={faGlobe} className="manager-card-icon webconsent" />
          <div className="manager-card-title">Web Consent</div>
          <div className="manager-card-desc">Collect and manage web app consents.</div>
          <button className="manager-card-btn">Open Web Consent</button>
        </div>

        <div className="manager-card drive-card" onClick={() => { setDriveResult(null); setDriveError(''); setDriveModalOpen(true); }}>
          <FontAwesomeIcon icon={faCloud} className="manager-card-icon drive" />
          <div className="manager-card-title">Drive Data</div>
          <div className="manager-card-desc">Choose a source and connect tenant data from Google Drive, One Drive, or Self Drive.</div>
          <button className="manager-card-btn" type="button" onClick={e => { e.stopPropagation(); setDriveResult(null); setDriveError(''); setDriveModalOpen(true); }}>Open Drive Data</button>
        </div>

        <div className="manager-card smtp-card" onClick={() => { setSmtpModalOpen(true); loadSmtpConfig(); }}>
          <FontAwesomeIcon icon={faEnvelope} className="manager-card-icon smtp" />
          <div className="manager-card-title">SMTP Settings</div>
          <div className="manager-card-desc">Add or update the tenant SMTP provider so consent and notification emails are sent from this tenant.</div>
          <button className="manager-card-btn" onClick={e => { e.stopPropagation(); setSmtpModalOpen(true); loadSmtpConfig(); }}>Manage SMTP</button>
        </div>
      </div>

      {/* Consent Choice Modal: Consent vs Web Consent */}
      {consentModalOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: 20
          }}
          onClick={() => setConsentModalOpen(false)}
        >
          <div
            style={{
              background: '#ffffff',
              borderRadius: 16,
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              width: '100%',
              maxWidth: 520,
              padding: '28px 32px',
              display: 'flex',
              flexDirection: 'column',
              gap: 20
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f1f5f9', paddingBottom: 14 }}>
              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#0f172a' }}>Select Consent Option</h3>
              <button
                type="button"
                onClick={() => setConsentModalOpen(false)}
                style={{ background: 'transparent', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 20, fontWeight: 700, padding: 4 }}
              >
                ✕
              </button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              {/* Option 1: Consent */}
              <div
                onClick={() => { setConsentModalOpen(false); setPage('consent'); }}
                style={{
                  border: '2px solid #e2e8f0',
                  borderRadius: 12,
                  padding: '24px 16px',
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'all 0.2s ease',
                  background: '#ffffff',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#2563eb'; e.currentTarget.style.background = '#eff6ff'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = '#ffffff'; }}
              >
                <div style={{ fontSize: 38, marginBottom: 10 }}>📋</div>
                <div style={{ fontWeight: 700, fontSize: 16, color: '#1e293b', marginBottom: 4 }}>Consent</div>
                <div style={{ fontSize: 12.5, color: '#64748b', lineHeight: 1.4 }}>Create & manage consent templates and records</div>
              </div>

              {/* Option 2: Web Consent */}
              <div
                onClick={() => { setConsentModalOpen(false); setPage('webapp-consent'); }}
                style={{
                  border: '2px solid #e2e8f0',
                  borderRadius: 12,
                  padding: '24px 16px',
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'all 0.2s ease',
                  background: '#ffffff',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#4f46e5'; e.currentTarget.style.background = '#eef2ff'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = '#ffffff'; }}
              >
                <div style={{ fontSize: 38, marginBottom: 10 }}>🌐</div>
                <div style={{ fontWeight: 700, fontSize: 16, color: '#1e293b', marginBottom: 4 }}>Web Consent</div>
                <div style={{ fontSize: 12.5, color: '#64748b', lineHeight: 1.4 }}>Collect & manage web app consents</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {smtpModalOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{
            background: '#fff', borderRadius: 14, width: 560, maxWidth: '100%',
            maxHeight: '90vh', boxShadow: '0 18px 40px rgba(0,0,0,0.24)',
            overflow: 'hidden', display: 'flex', flexDirection: 'column',
          }}>
            <div style={{ background: '#f59e0b', color: '#fff', padding: '16px 20px', fontWeight: 700, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span>Tenant SMTP Settings</span>
              <button type="button" onClick={() => { setSmtpModalOpen(false); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>✕</button>
            </div>

            <div style={{ padding: 20, display: 'grid', gap: 12, overflowY: 'auto', flex: 1 }}>

              <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '9px 13px', fontSize: 12, color: '#92400e' }}>
                <strong>Steps:</strong> Fill in details → click <strong>Test Connection</strong> → if green, click <strong>Save SMTP</strong>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(100px, 150px)', gap: 10, alignItems: 'end' }}>
                <div style={{ display: 'grid', gap: 6, minWidth: 0 }}>
                  <label style={{ fontSize: 13, fontWeight: 700 }}>SMTP Host *</label>
                  <input
                    value={smtpForm.host}
                    onChange={e => { setSmtpForm({ ...smtpForm, host: e.target.value }); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
                    placeholder="smtp.gmail.com"
                    style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', width: '100%', boxSizing: 'border-box' }}
                  />
                </div>
                <div style={{ display: 'grid', gap: 6, minWidth: 0 }}>
                  <label style={{ fontSize: 13, fontWeight: 700 }}>Port</label>
                  <input
                    type="number"
                    value={smtpForm.port}
                    onChange={e => { setSmtpForm({ ...smtpForm, port: e.target.value }); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
                    style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', width: '100%', boxSizing: 'border-box' }}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 700 }}>SMTP Username *</label>
                <input
                  value={smtpForm.username}
                  onChange={e => { setSmtpForm({ ...smtpForm, username: e.target.value }); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
                  placeholder="your@email.com"
                  style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px' }}
                />
              </div>

              <div style={{ display: 'grid', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 700 }}>SMTP Password / App Password</label>
                <input
                  type="password"
                  value={smtpForm.password}
                  onChange={e => { setSmtpForm({ ...smtpForm, password: e.target.value }); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
                  placeholder="Enter SMTP password / App password"
                  style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px' }}
                />
              </div>

              <div style={{ display: 'grid', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 700 }}>From Address *</label>
                <input
                  value={smtpForm.from_address}
                  onChange={e => { setSmtpForm({ ...smtpForm, from_address: e.target.value }); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
                  placeholder="noreply@yourdomain.com"
                  style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px' }}
                />
              </div>

              <div style={{ display: 'grid', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 700 }}>Test Email Address *
                  <span style={{ fontWeight: 400, color: '#6b7280', marginLeft: 6 }}>(receives the test email)</span>
                </label>
                <input
                  type="email"
                  value={smtpForm.test_email}
                  onChange={e => { setSmtpForm({ ...smtpForm, test_email: e.target.value }); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
                  placeholder="recipient@example.com"
                  style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px' }}
                />
              </div>

              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={smtpForm.use_tls}
                  onChange={e => { setSmtpForm({ ...smtpForm, use_tls: e.target.checked }); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
                />
                Use TLS / STARTTLS
              </label>

              {smtpTestMsg.type === 'ok' && (
                <div style={{ background: '#f0fdf4', border: '2px solid #16a34a', borderRadius: 8, padding: '11px 14px', color: '#166534', fontSize: 13, fontWeight: 700 }}>
                  Connection Successful — {smtpTestMsg.text}
                </div>
              )}
              {smtpTestMsg.type === 'err' && (
                <div style={{ background: '#fef2f2', border: '2px solid #dc2626', borderRadius: 8, padding: '11px 14px', color: '#b91c1c', fontSize: 13, fontWeight: 600 }}>
                  Connection Failed: {smtpTestMsg.text}
                </div>
              )}

              {smtpMessage ? <div style={{ color: '#b45309', fontSize: 13 }}>{smtpMessage}</div> : null}
            </div>

            <div style={{ padding: '14px 20px', display: 'flex', justifyContent: 'flex-end', gap: 10, borderTop: '1px solid #f0f0f0', flexShrink: 0, flexWrap: 'wrap' }}>
              <button
                style={{ border: '1px solid #cbd5e1', background: '#fff', color: '#334155', padding: '8px 14px', borderRadius: 8, cursor: 'pointer' }}
                onClick={() => { setSmtpModalOpen(false); setSmtpTestPassed(false); setSmtpTestMsg({ type: '', text: '' }); }}
              >
                Cancel
              </button>

              <button
                style={{
                  border: 'none',
                  background: smtpTesting ? '#9ca3af' : '#3b82f6',
                  color: '#fff', padding: '8px 16px', borderRadius: 8,
                  cursor: smtpTesting ? 'not-allowed' : 'pointer', fontWeight: 600,
                }}
                onClick={handleSmtpTest}
                disabled={smtpTesting}
              >
                {smtpTesting ? 'Testing...' : 'Test Connection'}
              </button>

              <button
                style={{
                  border: 'none',
                  background: smtpTestPassed ? '#f59e0b' : '#e5e7eb',
                  color: smtpTestPassed ? '#fff' : '#9ca3af',
                  padding: '8px 14px', borderRadius: 8,
                  cursor: smtpTestPassed && !smtpSaving ? 'pointer' : 'not-allowed',
                  fontWeight: 600, transition: 'background 0.2s',
                }}
                onClick={handleSmtpSave}
                disabled={!smtpTestPassed || smtpSaving}
                title={!smtpTestPassed ? 'Run Test Connection first' : 'Save SMTP to database'}
              >
                {smtpSaving ? 'Saving...' : 'Save SMTP'}
              </button>
            </div>
          </div>
        </div>
      )}

      {driveModalOpen && (
        <div onClick={() => setDriveModalOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', overflowY: 'auto', minHeight: '100vh' }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 16, width: 520, maxWidth: '100%',
            maxHeight: 'calc(100vh - 48px)', boxShadow: '0 18px 40px rgba(0,0,0,0.24)',
            overflow: 'hidden', display: 'flex', flexDirection: 'column',
          }}>
            <div style={{ background: '#2563eb', color: '#fff', padding: '18px 22px', fontWeight: 700, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span>Select Drive Source</span>
              <button type="button" onClick={() => setDriveModalOpen(false)} style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>✕</button>
            </div>
            <div style={{ padding: 20, overflowY: 'auto', flex: 1, minHeight: 0, display: 'grid', gap: 16 }}>
              <div style={{ display: 'grid', gap: 10 }}>
                {DRIVE_OPTIONS.map(option => (
                  <label key={option.key} style={{ display: 'flex', alignItems: 'center', gap: 10, border: selectedDrive === option.key ? '1px solid #2563eb' : '1px solid #e5e7eb', borderRadius: 10, padding: '12px 14px', cursor: 'pointer' }}>
                    <input
                      type="radio"
                      name="drive-option"
                      checked={selectedDrive === option.key}
                      onChange={() => {
                        setSelectedDrive(option.key);
                        setDriveError('');
                        setDriveResult(null);
                        setDriveAccessKey('');
                        setDriveAccessToken('');
                        setGoogleSignedIn(false);
                        setOneDriveSignedIn(false);
                        setGoogleAccountEmail('');
                        setOneDriveAccountEmail('');
                        resetDriveTestState();
                      }}
                    />
                    <span style={{ fontWeight: 600 }}>{option.label}</span>
                  </label>
                ))}
              </div>

              {isDriveConnected && (
                <div style={{ background: '#f0fdf4', border: '1.5px solid #86efac', borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                  <div>
                    <div style={{ color: '#166534', fontWeight: 700, fontSize: 13 }}>
                      ✓ Drive Connected: {getDriveOption(selectedDrive).label}
                    </div>
                    <div style={{ color: '#15803d', fontSize: 12, marginTop: 2 }}>
                      Client ID and Secret are locked. To change credentials or connect another account, click Disconnect.
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={handleDisconnectDrive}
                    style={{
                      border: '1px solid #dc2626', background: '#fff', color: '#dc2626',
                      padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 12, flexShrink: 0,
                    }}
                  >
                    Disconnect / Switch Account
                  </button>
                </div>
              )}

              {selectedDrive === 'google-drive' ? (
                <div style={{ marginTop: 10, display: 'grid', gap: 10 }}>
                  <div style={{ display: 'grid', gap: 6 }}>
                    <label style={{ fontSize: 13, fontWeight: 700 }}>Google OAuth Client ID</label>
                    <input
                      value={googleClientOverride}
                      disabled={isDriveConnected}
                      onChange={(e) => {
                        const v = e.target.value || '';
                        setGoogleClientOverride(v);
                        try {
                          if (window && window.localStorage) {
                            if (v && v.trim()) window.localStorage.setItem('google_client_override', v.trim());
                            else window.localStorage.removeItem('google_client_override');
                          }
                        } catch (ex) { }
                      }}
                      placeholder="e.g. 1234-abc.apps.googleusercontent.com"
                      style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', background: isDriveConnected ? '#f8fafc' : '#fff', color: isDriveConnected ? '#64748b' : '#111827', cursor: isDriveConnected ? 'not-allowed' : 'text' }}
                    />
                  </div>
                  <div style={{ display: 'grid', gap: 6 }}>
                    <label style={{ fontSize: 13, fontWeight: 700 }}>Google Client Secret</label>
                    <input
                      type="password"
                      value={driveClientSecret}
                      disabled={isDriveConnected}
                      onChange={(e) => {
                        const v = e.target.value || '';
                        setDriveClientSecret(v);
                        try {
                          if (window && window.localStorage) {
                            if (v && v.trim()) window.localStorage.setItem('drive_client_secret', v.trim());
                            else window.localStorage.removeItem('drive_client_secret');
                          }
                        } catch (ex) { }
                      }}
                      placeholder="Enter Google OAuth Client Secret"
                      style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', background: isDriveConnected ? '#f8fafc' : '#fff', color: isDriveConnected ? '#64748b' : '#111827', cursor: isDriveConnected ? 'not-allowed' : 'text' }}
                    />
                  </div>
                  {googleSignedIn ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, padding: '10px 12px', color: '#166534', fontSize: 13, fontWeight: 700 }}>
                      ✓ Signed in with Google{googleAccountEmail ? ` (${googleAccountEmail})` : ''}
                      {!isDriveConnected && (
                        <button
                          onClick={() => { setGoogleSignedIn(false); setGoogleAccountEmail(''); setDriveAccessKey(''); setDriveAccessToken(''); }}
                          style={{ marginLeft: 'auto', border: 'none', background: 'transparent', color: '#166534', cursor: 'pointer', fontWeight: 700, fontSize: 12, textDecoration: 'underline' }}
                        >
                          Switch account
                        </button>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={handleGoogleSignIn}
                      disabled={isDriveConnected || oauthConnecting}
                      style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                        border: '1px solid #d1d5db', background: isDriveConnected ? '#f1f5f9' : '#fff', color: isDriveConnected ? '#94a3b8' : '#3c4043',
                        padding: '10px 14px', borderRadius: 8, cursor: isDriveConnected || oauthConnecting ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 14,
                      }}
                    >
                      {oauthConnecting ? 'Connecting…' : 'Sign in with Google'}
                    </button>
                  )}
                </div>
              ) : selectedDrive === 'one-drive' ? (
                <div style={{ marginTop: 10, display: 'grid', gap: 10 }}>
                  <div style={{ display: 'grid', gap: 6 }}>
                    <label style={{ fontSize: 13, fontWeight: 700 }}>Microsoft OAuth Client ID</label>
                    <input
                      value={msClientOverride}
                      disabled={isDriveConnected}
                      onChange={(e) => {
                        const v = e.target.value || '';
                        setMsClientOverride(v);
                        try {
                          if (window && window.localStorage) {
                            if (v && v.trim()) window.localStorage.setItem('ms_client_override', v.trim());
                            else window.localStorage.removeItem('ms_client_override');
                          }
                        } catch (ex) { }
                      }}
                      placeholder="Paste Microsoft OAuth client ID"
                      style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', background: isDriveConnected ? '#f8fafc' : '#fff', color: isDriveConnected ? '#64748b' : '#111827', cursor: isDriveConnected ? 'not-allowed' : 'text' }}
                    />
                  </div>
                  <div style={{ display: 'grid', gap: 6 }}>
                    <label style={{ fontSize: 13, fontWeight: 700 }}>Microsoft Client Secret</label>
                    <input
                      type="password"
                      value={driveClientSecret}
                      disabled={isDriveConnected}
                      onChange={(e) => {
                        const v = e.target.value || '';
                        setDriveClientSecret(v);
                        try {
                          if (window && window.localStorage) {
                            if (v && v.trim()) window.localStorage.setItem('drive_client_secret', v.trim());
                            else window.localStorage.removeItem('drive_client_secret');
                          }
                        } catch (ex) { }
                      }}
                      placeholder="Enter Microsoft Client Secret"
                      style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', background: isDriveConnected ? '#f8fafc' : '#fff', color: isDriveConnected ? '#64748b' : '#111827', cursor: isDriveConnected ? 'not-allowed' : 'text' }}
                    />
                  </div>
                  {oneDriveSignedIn ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, padding: '10px 12px', color: '#166534', fontSize: 13, fontWeight: 700 }}>
                      ✓ Signed in with Microsoft{oneDriveAccountEmail ? ` (${oneDriveAccountEmail})` : ''}
                      {!isDriveConnected && (
                        <button
                          onClick={() => { setOneDriveSignedIn(false); setOneDriveAccountEmail(''); setDriveAccessKey(''); setDriveAccessToken(''); }}
                          style={{ marginLeft: 'auto', border: 'none', background: 'transparent', color: '#166534', cursor: 'pointer', fontWeight: 700, fontSize: 12, textDecoration: 'underline' }}
                        >
                          Switch account
                        </button>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={handleOneDriveSignIn}
                      disabled={isDriveConnected || oauthConnecting}
                      style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                        border: 'none', background: isDriveConnected ? '#94a3b8' : '#2564cf', color: '#fff',
                        padding: '10px 14px', borderRadius: 8, cursor: isDriveConnected || oauthConnecting ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 14,
                      }}
                    >
                      {oauthConnecting ? 'Connecting…' : 'Sign in with Microsoft'}
                    </button>
                  )}
                </div>
              ) : (
                <div style={{ marginTop: 10, display: 'grid', gap: 10 }}>
                  <div style={{ display: 'grid', gap: 6 }}>
                    <label style={{ fontSize: 13, fontWeight: 700 }}>Access Key / Client ID</label>
                    <input
                      value={driveAccessKey}
                      disabled={isDriveConnected}
                      onChange={(e) => setDriveAccessKey(e.target.value)}
                      placeholder="Enter access key or client ID"
                      style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', background: isDriveConnected ? '#f8fafc' : '#fff', color: isDriveConnected ? '#64748b' : '#111827', cursor: isDriveConnected ? 'not-allowed' : 'text' }}
                    />
                  </div>
                  <div style={{ display: 'grid', gap: 6 }}>
                    <label style={{ fontSize: 13, fontWeight: 700 }}>Access Token / Client Secret</label>
                    <input
                      type="password"
                      value={driveAccessToken}
                      disabled={isDriveConnected}
                      onChange={(e) => setDriveAccessToken(e.target.value)}
                      placeholder="Enter access token or client secret"
                      style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: '8px 10px', background: isDriveConnected ? '#f8fafc' : '#fff', color: isDriveConnected ? '#64748b' : '#111827', cursor: isDriveConnected ? 'not-allowed' : 'text' }}
                    />
                  </div>
                </div>
              )}
              {driveTestMsg.type === 'ok' && (
                <div style={{ background: '#f0fdf4', border: '2px solid #16a34a', borderRadius: 8, padding: '11px 14px', color: '#166534', fontSize: 13, fontWeight: 700 }}>
                  ✓ {driveTestMsg.text}
                </div>
              )}
              {driveTestMsg.type === 'err' && (
                <div style={{ background: '#fef2f2', border: '2px solid #dc2626', borderRadius: 8, padding: '11px 14px', color: '#b91c1c', fontSize: 13, fontWeight: 600 }}>
                  ✗ Connection Failed: {driveTestMsg.text}
                </div>
              )}
              {driveError && !driveTestMsg.text ? <div style={{ marginTop: 12, color: '#dc2626', fontSize: 13 }}>{driveError}</div> : null}
              {driveResult ? (
                <div style={{ marginTop: 12, background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 10, padding: 12, color: '#166534' }}>
                  <div style={{ fontWeight: 700 }}>Drive data fetched successfully</div>
                  <div style={{ fontSize: 13, marginTop: 4 }}>Drive: {driveResult.drive_label || getDriveOption(selectedDrive).label}</div>
                  <div style={{ fontSize: 13 }}>Tenant: {driveResult.tenant_name || org.name}</div>
                  <div style={{ fontSize: 13 }}>Storage path: {driveResult.storage_path || 'Not available'}</div>
                  {typeof driveResult.file_count === 'number' ? (
                    <div style={{ fontSize: 13 }}>Files found: {driveResult.file_count}</div>
                  ) : null}
                  <div style={{ fontSize: 13 }}>Records found: {driveResult.record_count || 0}</div>
                  {Array.isArray(driveResult.files) && driveResult.files.length > 0 ? (
                    <div style={{ marginTop: 8, display: 'grid', gap: 6, maxHeight: 240, overflowY: 'auto' }}>
                      <div style={{ fontWeight: 700, color: '#166534' }}>Drive files</div>
                      {driveResult.files.slice(0, 5).map((file, index) => (
                        <div key={`${file.name}-${index}`} style={{ background: '#fff', border: '1px solid #bbf7d0', borderRadius: 8, padding: '8px 10px', fontSize: 12, color: '#111827' }}>
                          <div style={{ fontWeight: 700 }}>{file.name}</div>
                          <div style={{ color: '#4b5563', marginTop: 2 }}>{(file.size || 0).toLocaleString()} bytes • {file.modified_at || 'N/A'}</div>
                          {file.url ? (
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                              <a
                                href={getFileUrl(file.url)}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', color: '#1d4ed8', fontWeight: 700 }}
                              >
                                View
                              </a>
                              <a
                                href={getFileDownloadUrl(file.url)}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', color: '#047857', fontWeight: 700 }}
                              >
                                Download
                              </a>
                            </div>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  ) : null}
                  {!Array.isArray(driveResult.files) && (!Array.isArray(driveResult.records) || driveResult.records.length === 0) ? (
                    <div style={{ marginTop: 8, fontSize: 12 }}>No data returned for this drive selection.</div>
                  ) : null}
                </div>
              ) : null}
            </div>
            <div style={{ padding: '14px 20px', display: 'flex', justifyContent: 'flex-end', gap: 10, borderTop: '1px solid #f0f0f0', flexShrink: 0, flexWrap: 'wrap' }}>
              <button
                type="button"
                style={{ border: '1px solid #cbd5e1', background: '#fff', color: '#334155', padding: '8px 14px', borderRadius: 8, cursor: 'pointer' }}
                onClick={() => { setDriveModalOpen(false); resetDriveTestState(); }}
              >
                Cancel
              </button>

              <button
                type="button"
                style={{
                  border: 'none',
                  background: driveTesting ? '#9ca3af' : '#2563eb',
                  color: '#fff', padding: '8px 16px', borderRadius: 8,
                  cursor: driveTesting ? 'not-allowed' : 'pointer', fontWeight: 600,
                }}
                onClick={handleTestDrive}
                disabled={driveTesting}
              >
                {driveTesting ? 'Testing...' : 'Test Drive'}
              </button>

              <button
                type="button"
                style={{
                  border: 'none',
                  background: driveTestPassed ? '#10b981' : '#e5e7eb',
                  color: driveTestPassed ? '#fff' : '#9ca3af',
                  padding: '8px 16px', borderRadius: 8,
                  cursor: driveTestPassed && !driveLoading ? 'pointer' : 'not-allowed',
                  fontWeight: 600, transition: 'background 0.2s',
                }}
                onClick={handleConnectDrive}
                disabled={!driveTestPassed || driveLoading}
                title={!driveTestPassed ? 'Run Test Drive first' : 'Connect selected drive'}
              >
                {driveLoading ? 'Saving...' : 'Connect Drive'}
              </button>
            </div>
          </div>
        </div>
      )}

      {subscriptionOpen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 3000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'rgba(0,0,0,0.50)',
        }}>
          <div style={{
            background: '#fff', borderRadius: 12, width: 500, maxWidth: '95%',
            maxHeight: '85vh', boxShadow: '0 20px 60px rgba(0,0,0,0.22)',
            fontFamily: "'Segoe UI', sans-serif", overflow: 'hidden',
            display: 'flex', flexDirection: 'column',
          }}>
            <div style={{
              background: '#4979ea', color: '#fff', padding: '16px 22px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0,
            }}>
              <strong style={{ fontSize: 17 }}>Manage Subscription</strong>
              <button onClick={() => setSubscriptionOpen(false)}
                style={{ background: 'none', border: 'none', color: '#fff', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}>
                ✕
              </button>
            </div>

            <div style={{ padding: '20px 22px', overflowY: 'auto', flex: 1 }}>
              <p style={{ margin: '0 0 16px', color: '#444', fontSize: 14 }}>
                Choose billing duration and number of users for <strong>{org.name}</strong>
              </p>

              <div style={{ fontSize: 12, fontWeight: 700, color: '#555', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                Duration
              </div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
                {[1, 6, 12].map(m => (
                  <button key={m} onClick={() => setSelectedMonths(m)} style={{
                    flex: 1, padding: '9px 0', borderRadius: 6, cursor: 'pointer', fontSize: 14,
                    border: selectedMonths === m ? '2px solid #5182f6' : '1px solid #dde1ea',
                    background: selectedMonths === m ? '#4776e3' : '#f5f7fc',
                    color: selectedMonths === m ? '#fff' : '#4c98ee',
                    fontWeight: selectedMonths === m ? 700 : 400,
                    transition: 'all 0.15s',
                  }}>
                    {m} {m === 1 ? 'Month' : 'Months'}
                  </button>
                ))}
              </div>

              <div style={{ fontSize: 12, fontWeight: 700, color: '#555', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                Number of Users
              </div>
              <input
                type="number" min={1} value={selectedUsers}
                onChange={e => setSelectedUsers(Math.max(1, parseInt(e.target.value || '1', 10)))}
                style={{
                  width: '100%', padding: '9px 12px', border: '1px solid #dde1ea',
                  borderRadius: 6, fontSize: 15, boxSizing: 'border-box', marginBottom: 18,
                }}
              />

              <div style={{
                background: '#f7f9ff', border: '1px solid #e0e6f5',
                borderRadius: 8, padding: '10px 14px', marginBottom: 18, fontSize: 13,
              }}>
                <div style={{ fontWeight: 700, marginBottom: 8, color: '#2a3a5e' }}>Price Tiers (per user / month)</div>
                {[
                  { label: '1–5 users', rate: tier1Rate, active: selectedUsers <= 5 },
                  { label: '6–15 users', rate: tier2Rate, active: selectedUsers > 5 && selectedUsers <= 15 },
                  { label: '16+ users', rate: tier3Rate, active: selectedUsers > 15 },
                ].map(({ label, rate, active }) => (
                  <div key={label} style={{
                    display: 'flex', justifyContent: 'space-between', padding: '4px 0',
                    color: active ? '#2a3a5e' : '#888',
                    fontWeight: active ? 700 : 400,
                  }}>
                    <span>{label} {active && '✓'}</span>
                    <span>₹{rate} / user</span>
                  </div>
                ))}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <div>
                  <div style={{ fontSize: 12, color: '#888', marginBottom: 2 }}>Estimated Total (excl. 18% GST)</div>
                  <div style={{ fontSize: 24, fontWeight: 700, color: '#2a3a5e' }}>₹{formatINR(calculateTotalINR())}</div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                    {selectedUsers} user(s) × {selectedMonths} month(s) × ₹{rateForUsers(selectedUsers)}
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              padding: '14px 22px', borderTop: '1px solid #eee',
              display: 'flex', justifyContent: 'flex-end', gap: 10,
              background: '#fafbfd', flexShrink: 0,
            }}>
              <button
                onClick={() => setSubscriptionOpen(false)}
                style={{ padding: '9px 20px', border: '1px solid #ccc', borderRadius: 6, background: '#fff', cursor: 'pointer', fontSize: 14 }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setSubscriptionOpen(false);
                  setShowSubscriptionModal(true);
                }}
                style={{
                  padding: '9px 22px', border: 'none', borderRadius: 6,
                  background: '#4d7ce8', color: '#fff', cursor: 'pointer',
                  fontSize: 14, fontWeight: 700,
                }}
              >
                Proceed to Payment →
              </button>
            </div>
          </div>
        </div>
      )}

      <SubscriptionModal
        show={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
        user={{
          email: org.manager_email,
          organization: org.name,
          address: org.address,
          gst_number: org.gst_number,
          pan_number: org.pan_number,
          preSelectedUsers: selectedUsers,
          preSelectedMonths: selectedMonths,
        }}
      />
    </div>
  );
}

export default ManagerPanel;